var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isNil } from "lodash";
import { Row, Col } from "react-bootstrap";
import React, { PureComponent, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import teamService from "@irati/identity/services/teams";
import userService from "@irati/identity/services/users";
import Card from "@irati/ui/src/Layout/Card";
import Loading from "@irati/ui/src/Loading";
import Input from "@irati/ui/src/FormItem/Input";
import Success from "@irati/ui/src/Success";
import Modal from "@irati/ui/src/Modal";
import { Radio } from "@irati/ui/src/FormItem";
import Form from "@irati/ui/src/Form";
import { H1 } from "@irati/ui/src/Typography";
import { Para } from "@irati/ui/src/Labels";
import Validation from "@irati/utils/validation";
import { genderOptions as genders } from "@irati/identity/constants/genders";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import DOBSelect from "@irati/ui/src/DOBSelect";
import { Firstname, Lastname, Email, Locale } from "@irati-web/fields/user";
import { dobObjectToString, dobStringToObject } from "@irati/identity/utils/user/dob";
import Flex from "@irati/ui/src/Flex";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Button from "@irati/ui/src/Button";
import EditProfilePic from "../../components/EditProfilePic";
var RadioWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 340px;\n"], ["\n  max-width: 340px;\n"])));
var UpdateUserContainer = /** @class */ (function (_super) {
    __extends(UpdateUserContainer, _super);
    function UpdateUserContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.dobInput = createRef();
        _this.fetchUserAndTeams = function () {
            return userService.get(_this.props.user.uuid).then(function (user) {
                return teamService.list(user.businessId).then(function (teams) {
                    var teamNames = teams.filter(function (team) { return user.teamIds.includes(team.uuid); }).map(function (team) { return team.public_name; });
                    return _this.setState(__assign({ teams: teamNames.join(",") }, _this.buildUserState(user)));
                });
            });
        };
        _this.buildGenders = function () {
            var formatMessage = _this.props.formatMessage;
            return genders.map(function (gender) {
                return __assign(__assign({}, gender), { label: formatMessage({ id: gender.label }) });
            });
        };
        _this.buildUserState = function (user) {
            return {
                firstName: user ? user.firstName : undefined,
                lastName: user ? user.lastName : undefined,
                gender: user ? user.gender : undefined,
                dateOfBirth: user ? user.dateOfBirth : undefined,
                email: user ? user.email : undefined,
                language: user ? user.language : undefined,
                phoneNumber: !user || isNil(user.phoneNumber) ? undefined : user.phoneNumber
            };
        };
        _this.updateInput = function (label, value) {
            var _a;
            _this.setState((_a = {
                    hasEdited: true
                },
                _a[label] = value,
                _a));
        };
        _this.undoAll = function () {
            var dateOfBirth = _this.props.user.dateOfBirth;
            if (_this.dobInput.current) {
                _this.dobInput.current.reset(dobObjectToString(dateOfBirth || {}));
            }
            _this.fetchUserAndTeams();
            _this.setState({
                hasEdited: false
            });
        };
        _this.updateDetails = function () {
            var user = _this.props.user;
            var _a = _this.state, firstName = _a.firstName, lastName = _a.lastName, email = _a.email, dateOfBirth = _a.dateOfBirth, phoneNumber = _a.phoneNumber, gender = _a.gender, language = _a.language;
            var data = {
                uuid: user.uuid,
                firstName: firstName && firstName.trim(),
                lastName: lastName && lastName.trim().length > 0 ? lastName.trim() : null,
                email: email,
                dateOfBirth: dateOfBirth,
                phoneNumber: phoneNumber,
                gender: gender,
                language: language
            };
            var submit = userService.update({ user: data }).then(function () {
                _this.showSuccessMessage();
                _this.setState({
                    hasEdited: false
                });
                setTimeout(_this.hideSuccessMessage, 2000);
            });
            _this.setState({ submit: submit });
            return submit;
        };
        _this.showSuccessMessage = function () { return _this.setState({ showSuccessMessage: true }); };
        _this.hideSuccessMessage = function () { return _this.setState({ showSuccessMessage: false }); };
        _this.mobileValidation = function () {
            var formatMessage = _this.props.formatMessage;
            /* eslint-disable */
            return _this.addSSOValidation(Validation.string()
                .transform(function (value) { return (!value ? null : value); })
                .min(7, formatMessage({ id: "account.profile.fields.phone.validation.min" }))
                .max(15, formatMessage({ id: "account.profile.fields.phone.validation.max" }))
                .matches(/^[+]?([\d]{0,3})?[\(\.\-\s]?(([\d]{1,3})[\)\.\-\s]*)?(([\d]{3,5})[\.\-\s]?([\d]{4})|([\d]{2}[\.\-\s]?){4})$/, formatMessage({ id: "account.profile.fields.phone.validation.matches" })), "phoneNumber");
            /* eslint-enable */
        };
        _this.addSSOValidation = function (validation, key) {
            var _a = _this.props, formatMessage = _a.formatMessage, user = _a.user;
            if (!user.isManagedExternally) {
                return validation;
            }
            return validation.test("isSSOuser", formatMessage({ id: "account.profile.addSSOValidation.test" }), function (value) {
                return (value || "") === (user[key] || "");
            });
        };
        _this.buildFirstNameValidation = function () {
            var formatMessage = _this.props.formatMessage;
            return _this.addSSOValidation(Validation.string(formatMessage({ id: "account.profile.fields.firstname.validation.string" }))
                .max(50)
                .test("notJustSpaces", formatMessage({ id: "account.profile.fields.firstname.validation.test" }), function (value) { return value && value.trim().length !== 0; }), "firstName");
        };
        _this.buildLastNameValidation = function () {
            return _this.addSSOValidation(Validation.string()
                .min(2, _this.props.formatMessage({ id: "account.profile.fields.lastname.validation" }))
                .max(50), "lastName");
        };
        _this.buildEmailValidation = function () {
            var formatMessage = _this.props.formatMessage;
            return _this.addSSOValidation(Validation.string(formatMessage({ id: "account.profile.fields.email.validation.required" }))
                .max(255)
                .email(formatMessage({ id: "account.profile.fields.email.validation.email" })), "email");
        };
        var load = _this.fetchUserAndTeams();
        _this.state = {
            load: load,
            submit: null,
            teams: "",
            showSuccessMessage: false,
            hasEdited: false,
            firstName: undefined,
            lastName: undefined,
            gender: undefined,
            dateOfBirth: undefined,
            email: undefined,
            language: undefined,
            phoneNumber: undefined
        };
        return _this;
    }
    UpdateUserContainer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var user = nextProps.user;
        if (user && user !== this.props.user) {
            this.setState(this.buildUserState(user));
        }
    };
    UpdateUserContainer.prototype.render = function () {
        var _this = this;
        var _a = this.state, load = _a.load, submit = _a.submit, showSuccessMessage = _a.showSuccessMessage, teams = _a.teams, firstName = _a.firstName, lastName = _a.lastName, email = _a.email, phoneNumber = _a.phoneNumber, dateOfBirth = _a.dateOfBirth, language = _a.language, gender = _a.gender, hasEdited = _a.hasEdited;
        var _b = this.props, formatMessage = _b.formatMessage, isMobile = _b.isMobile;
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, { tiny: true, noBorder: true },
                React.createElement("div", { className: "updateUser_form" },
                    React.createElement(Form, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 12 },
                                React.createElement(H1, { marginBottom: 4 },
                                    React.createElement(FormattedMessage, { id: "account.profile.header" })))),
                        React.createElement(Loading, { load: load },
                            React.createElement(Flex, { direction: "column", maxWidth: "480px" },
                                React.createElement(EditProfilePic, null),
                                React.createElement(Para, null,
                                    React.createElement(FormattedMessage, { id: "account.profile.fields.teams.label" })),
                                React.createElement(Para, null, teams),
                                React.createElement(Firstname, { value: firstName, onChange: function (value) { return _this.updateInput("firstName", value); }, validation: this.buildFirstNameValidation() }),
                                React.createElement(Lastname, { value: lastName, onChange: function (value) { return _this.updateInput("lastName", value); }, validation: this.buildLastNameValidation() }),
                                React.createElement(Email, { value: email, onChange: function (value) { return _this.updateInput("email", value); }, validation: this.buildEmailValidation() }),
                                React.createElement(Locale, { value: language, onChange: function (value) { return _this.updateInput("language", value); } }),
                                React.createElement(RadioWrapper, null,
                                    React.createElement(Radio, { name: "preferredPronoun", label: formatMessage({ id: "account.profile.fields.pronoun.label" }), inline: !isMobile, value: gender, options: this.buildGenders(), onChange: function (value) { return _this.updateInput("gender", value); } })),
                                React.createElement(DOBSelect, { label: formatMessage({ id: "account.profile.fields.dob.label" }), value: dobObjectToString(dateOfBirth || {}), ref: this.dobInput, onChange: function (value) { return _this.updateInput("dateOfBirth", dobStringToObject(value || "")); } }),
                                React.createElement(Input, { label: formatMessage({ id: "account.profile.fields.mobile.label" }), value: phoneNumber, name: "phone", onChange: function (value) { return _this.updateInput("phoneNumber", value); }, validation: this.mobileValidation() })),
                            React.createElement(Loading, { load: submit, useLoader: false }),
                            React.createElement(Flex, { marginTop: 1 },
                                React.createElement(ValidationButton, { large: true, primary: true, onClick: this.updateDetails, load: submit, marginRight: 2 },
                                    React.createElement(FormattedMessage, { id: "account.popup.save" })),
                                hasEdited && (React.createElement(Button, { large: true, onClick: this.undoAll },
                                    React.createElement(FormattedMessage, { id: "account.popup.undo" })))))))),
            React.createElement(Modal, { show: showSuccessMessage, onHide: this.hideSuccessMessage },
                React.createElement(Success, { message: formatMessage({ id: "account.profile.updateSuccessful" }) }))));
    };
    UpdateUserContainer.propTypes = {
        getTeams: PropTypes.func.isRequired
    };
    return UpdateUserContainer;
}(PureComponent));
var mapStateToProps = function (state) {
    return {
        user: state.auth.user,
        isMobile: state.mq.lessThan.medium
    };
};
export default injectIntl(connect(mapStateToProps)(UpdateUserContainer), { withRef: true });
var templateObject_1;
